import { getBenchatService } from '../../service/benchatService';

app.service('benchatService', ['$http', getBenchatService]);
